import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
	ticketsListWrapper: {
		position: "relative",
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflow: "hidden",
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		gap: 5,
	},

	ticketsList: {
		flex: 1,
		...theme.scrollbarStyles,
		// borderTop: "2px solid rgba(0, 0, 0, 0.12)",
		overflow: "auto",
		paddingBottom: "2rem",
		background: theme.palette.background.default,
	},

	ticketsListHeader: {
		color: "rgb(67, 83, 105)",
		zIndex: 2,
		backgroundColor: "white",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},

	ticketsCount: {
		fontWeight: "normal",
		color: "rgb(104, 121, 146)",
		marginLeft: "8px",
		fontSize: "14px",
	},

	noTicketsText: {
		textAlign: "center",
		color: "rgb(104, 121, 146)",
		fontSize: "14px",
		lineHeight: "1.4",
	},

	noTicketsTitle: {
		textAlign: "center",
		fontSize: "16px",
		fontWeight: "600",
		margin: "0px",
	},

	noTicketsDiv: {
		display: "flex",
		height: "100px",
		margin: 40,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},

	msgFinal: {
		fontSize: "0.8rem",
		fontWeight: "bolder",
		textAlign: "center",
		borderTop: "1px solid rgba(0, 0, 0, 0.12)",
		padding: "1rem 1rem 2rem 1rem",
		color: "#777676",
		marginBottom: 30
	}
}));
